import { DeleteIcon, EditIcon } from '@/components/_common';
import {
  useFunctionRemove,
  useFunctions,
} from '@/core/domain/enterprise/Functions/Functions.hooks';
import {
  EmployeeFunction,
  EmployeeFunctionRequestParams,
} from '@/core/domain/enterprise/Functions/Functions.types';
import { useDebounce } from '@/hooks';
import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';
import { getTableScrollX } from '@/utils/table';
import { Divider, Modal, Space, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import FunctionsUpdateModal from '../FunctionsUpdateModal';
import { useState } from 'react';

export default function FunctionsList({
  queryParams,
}: ExtraFiltersProps<EmployeeFunctionRequestParams>) {
  const queryDebounce = useDebounce(queryParams);
  const [employeeFunction, setEmployeeFunction] = useState<EmployeeFunction>();

  const functions = useFunctions(queryDebounce);
  const remove = useFunctionRemove();

  const handleRemoveClick = (employeeFunction: EmployeeFunction) => {
    Modal.confirm({
      title: 'Excluir Cargo',
      content: (
        <p>
          Tem certeza de que deseja remover o seguinte Cargo?
          <br />
          <br />"
          <strong>{`${employeeFunction.name} - ${employeeFunction.code}`}</strong>
          "
        </p>
      ),
      onOk: async () => {
        await remove.mutateAsync(employeeFunction.id);
      },
      okText: 'Remover',
      okType: 'danger',
    });
  };

  const columns: ColumnsType<EmployeeFunction> = [
    {
      dataIndex: 'name',
      title: 'Nome',
      ellipsis: true,
      width: 120,
    },
    {
      dataIndex: 'code',
      title: 'Código',
      ellipsis: true,
      width: 120,
    },
    {
      title: 'Ações',
      align: 'right',
      fixed: 'right',
      width: 120,
      render: (_, rows) => (
        <Space>
          <EditIcon iconProps={{ onClick: () => setEmployeeFunction(rows) }} />

          <Divider type="vertical" />

          <DeleteIcon onClick={() => handleRemoveClick(rows)} />
        </Space>
      ),
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={functions.data}
        loading={functions.isFetching}
        rowKey={(row) => row.id}
        pagination={false}
        scroll={{ x: getTableScrollX(columns) }}
      />

      <FunctionsUpdateModal
        open={!!employeeFunction}
        onCancel={() => setEmployeeFunction(undefined)}
        employeeFunction={employeeFunction}
      />
    </>
  );
}
